// ON LOAD ////////////////////////////////////////////////////////////////////
onDomReady(function() {
   // Preload UI frame images.
   [window.cart_constants.BaseURI('SITEIMAGE_LOADING')].each(function(src) {
      new Asset.image(src);
   });
});
